// extracted by mini-css-extract-plugin
export var copy = "vintage_pdp-module--copy--fb9d6";
export var cta = "vintage_pdp-module--cta--a6fe7";
export var data = "vintage_pdp-module--data--d4a47";
export var desc = "vintage_pdp-module--desc--4b0aa";
export var details = "vintage_pdp-module--details--4ecd2";
export var disable = "vintage_pdp-module--disable--c3ad0";
export var images = "vintage_pdp-module--images--e3c09";
export var info = "vintage_pdp-module--info--9cc8f";
export var label = "vintage_pdp-module--label--12c0f";
export var nd_ctaLink = "vintage_pdp-module--nd_cta-link--ff048";
export var price = "vintage_pdp-module--price--d9ef1";
export var ship = "vintage_pdp-module--ship--a02f4";
export var title = "vintage_pdp-module--title--20a6e";
export var vinsp = "vintage_pdp-module--vinsp--5c49d";
export var vinsp_cont = "vintage_pdp-module--vinsp_cont--18653";
export var vinsp_conts = "vintage_pdp-module--vinsp_conts--efb9a";
export var vinsp_image = "vintage_pdp-module--vinsp_image--f5dac";
export var vinsp_img = "vintage_pdp-module--vinsp_img--d3cda";
export var vpdp = "vintage_pdp-module--vpdp--85c90";
export var vpdp_wr = "vintage_pdp-module--vpdp_wr--9b090";